<template>
  <AnalyzerForm
    :analyzer="$store.state.analyzers.analyzer"
    :onSubmit="submit"
  ></AnalyzerForm>
</template>

<script>
import { mapActions } from 'vuex';
import AnalyzerForm from './AnalyzerForm.vue';
import { busEvent } from '../../main';

export default {
  name: 'EditAnalyzer',
  components: {
    AnalyzerForm,
  },
  created() {
    this.getAnalyzer(this.$route.params.id);
  },
  methods: {
    ...mapActions('analyzers', ['getAnalyzer', 'update']),

    async submit() {
      await this.update(this.$route.params.id);
      busEvent.$emit('succesPopupCreated', 'Informatie actualizata');
      this.$router.push({ path: '/analyzers' });
    },
  },
};
</script>
